<!-- 히든 포커칩 정보 -->
<div data-user-popup class="myhiddenchip">
  <div class="myhiddenchip__head">
    <div class="myhiddenchip__title">히든포커칩</div>
    <a class="myhiddenchip__close" href="#" onclick="$(this).parents('.myhiddenchip').hide(); return false;">닫기</a>
  </div>
  <div class="myhiddenchip__box">
    <div class="myhiddenchip__chip">
      <span class="icon__pokerchip--big"></span>
      {{{pchipHiddenTag}}}<strong>칩</strong>
    </div>
    {{#if canDepositPchip}}
    <a href="#" data-user-action="depositPchip" class="myhiddenchip__put-chip">포커칩 입금하기</a>
    {{/if}}
    {{#if canWithdrawPchip}}
    <a href="#" data-user-action="withdrawPchip" class="myhiddenchip__put-chip">포커칩 출금하기</a>
    {{/if}}
  </div>
  <div class="myhiddenchip__notice">
    <h3>히든 포커칩이란?</h3>
    <p>포커칩 10만칩을 입/출금 할 수 있는 기능입니다.</p>
    <p>포커칩 입금 후 포커칩 채널에서 올인 당했을 때,</p>
    <p>비상금으로 사용할 수 있습니다.</p>
    <p>소지한 포커칩이 11만칩 이상일 경우 입금 가능합니다.</p>
  </div>
</div>